import { render, staticRenderFns } from "./BasePeriodPicker.vue?vue&type=template&id=54efb6e2"
import script from "./BasePeriodPicker.vue?vue&type=script&lang=js"
export * from "./BasePeriodPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports